module.exports = __webpack_public_path__ + "media/images/next-arrow-224343cf0a7c72127713cc5e9270edbc.svg";